import React, { FC } from 'react';
import { IonIcon } from '@ionic/react';
import { informationCircle } from 'ionicons/icons';
import { HelpButtonStyled } from './HelpButton.style';
import useIntercomPlugin from 'src/shared/hooks/useIntercomPlugin';

type HelpButtonProps = {
  articleId: number;
  className?: string;
  style?: React.CSSProperties;
};

const HelpButton: FC<HelpButtonProps> = ({ articleId, children, ...props }) => {
  const { displayArticle } = useIntercomPlugin();

  return (
    <HelpButtonStyled
      onClick={async () => {
        await displayArticle(articleId);
      }}
      {...props}
    >
      <IonIcon icon={informationCircle} /> {children}
    </HelpButtonStyled>
  );
};

export default HelpButton;
